import React from "react";          
import { IHCPViewProps } from "src/components/portal/views/HCPDashboardLayout/interfaces";
import useActiveProject from "src/components/_shared/hooks/useProject/useActiveProject";
import { PortalSection } from "src/components/portal/_shared/components/PortalSection";
import { DTC_PORTAL_NEXT_STEPS_ID } from "src/components/portal/views/HCPDashboardLayout/HCPTitleNav/navigation_ids";
import { NextStepsComponent } from "src/components/portal/views/HCPDashboardLayout/HCPNextSteps/components/NextStepsComponent";

export const PrimaryHomesNextStep = (props: IHCPViewProps) => {
  const {width} = props;
  const {site} =
    useActiveProject();

  if (!site?.visible) {
    return null;
  }

  return (
    <PortalSection
      headerTitle={"Next Steps"}
      width={width}
      sectionId={DTC_PORTAL_NEXT_STEPS_ID}
    >
      <NextStepsComponent step={4} />
    </PortalSection>
  );
};
